module.exports = __webpack_public_path__ + "img/id-front-eg.4df12caf.jpg";